<template>
    <div>
        <sweet-modal ref="operatorBrandModal" :modal-theme="$vuetify.theme.dark === true ? 'dark' : 'light'" :overlay-theme="$vuetify.theme.dark === true ? 'light' : 'dark'" blocking>

            <v-container v-if="!isBusy">
                <h3 class="mb-3">
                    Edit Operator Brands
                </h3>
                <h5 class="mb-6">Operator brands are used for all report filters and access to what data the operator can see with the keyboards given below</h5>
                <v-row>
                    <v-col cols="12">
                        <v-row>
                            <v-col cols="10">
                                <v-text-field v-model="brandName"
                                              :counter="250"
                                              label="New Brand Name"></v-text-field>
                            </v-col>
                            <v-col cols="2" class="mt-4">
                                <v-btn color="default" @click="onAddBrand">
                                    Add
                                </v-btn>
                            </v-col>
                        </v-row>

                        <div class="text-left">
                            <v-chip v-for="brand in operatorBrands" :key="brand.name" class="ma-2" close @click:close="onRemoveBrand(brand.id)">
                                {{brand.name}}
                            </v-chip>
                        </div>

                    </v-col>
                </v-row>
            </v-container>

            <v-skeleton-loader v-if="isBusy" v-bind="attrs"
                               type="table-heading, list-item-two-line, image, table-tfoot"></v-skeleton-loader>
        </sweet-modal>
    </div>
</template>

<script>
    import OperatorService from "../../services/operatorService.js"
    export default {
        data() {
            return {
                operatorId: "",
                attrs: null,
                accessToken: "",
                isBusy: true,
                operatorBrands: [],
                brandName: ""
            }
        },
        created() {
            this.setup();
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();
            },
            async open(operatorId) {
                this.$refs.operatorBrandModal.open();

                this.operatorId = operatorId;

                await this.getOperatorBrands();
            },
            async getOperatorBrands() {
                this.isBusy = true;

                const result = await OperatorService.getOperatorById(this.operatorId, this.accessToken);

                if (result) {
                    this.operatorBrands = result.operatorBrands;
                }

                this.isBusy = false;
            },
            onRemoveBrand(brandName) {
                if (this.operatorBrands.some(brand => brand.name.toLowerCase() === brandName.toLowerCase())) {
                    this.operatorBrands.splice(brandName, 1);
                }
            },
            async onAddBrand() {
                this.isBusy = true;

                const request = {
                    name: this.brandName
                }

                const result = await OperatorService.createOperatorBrand(this.operatorId, request, this.accessToken);

                if (result) {
                    await this.getOperatorBrands();
                }

                this.isBusy = false;
            }
        }
    };
</script>
